import { render, staticRenderFns } from "./DineinProductMangement.vue?vue&type=template&id=dfa5d4f2&scoped=true"
import script from "./DineinProductMangement.vue?vue&type=script&lang=js"
export * from "./DineinProductMangement.vue?vue&type=script&lang=js"
import style0 from "./DineinProductMangement.vue?vue&type=style&index=0&id=dfa5d4f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa5d4f2",
  null
  
)

export default component.exports